<template>
<div class="error">
  <div class="error__container">
    <p class="error__word"><span class="pri">4</span><span class="sec">0</span><span class="thr">4</span></p>
    <p class="error__comment">Problemas al conectar con el servidor</p>
    <button class="error__exit btn-scale" @click="$router.push({name: 'panel'})">Sácame de aquí</button>
  </div>
</div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
@keyframes move {
  0% {
    transform: translateY(-15px);
  }
  100% {
    transform: translateY(15px)
  }
}

.pri{
  animation-name: move;
  animation-timing-function: ease-out;
  animation-iteration-count: infinite;
  animation-duration: 3s;
  display: inline-block;
  animation-direction: alternate;
}

.thr{
  animation-name: move;
  animation-timing-function: ease-out;
  animation-iteration-count: infinite;
  animation-duration: 3s;
  animation-delay: 1s;
  display: inline-block;
  animation-direction: alternate;
}

.sec{
  animation-name: move;
  animation-timing-function: ease-out;
  animation-direction: alternate-reverse;
  animation-iteration-count: infinite;
  animation-duration: 3s;
  display: inline-block;
}
.error{
  width: 100%;
  height: 100%;
  font-family: montserrat;
  background: url('../assets/img/stars.png'), #141b39;
  display: flex;
  // background-position: center;
  justify-content: center;
  align-items: center;

  &__container{
    margin-top: -2rem
  }

  &__word{
    font-size: calc(17vw + 40px);
    line-height: calc(17vw + 40px);
    font-weight: 900;
    color: #d8ff00;
    display: flex;
    justify-content: center
  }
  &__comment{
    color: #fff;
    text-align: center;
    margin-top: 3rem;
  }

  &__exit{
    display: block;
    margin: 2rem auto;
    color: #fff;
    background-color: #1e8feb;
    border-radius: 6px;
    padding: .5rem 1rem;
    font-size: .9rem;
  }
}
</style>
